(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["launch-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('launch-countdown')) {
  customElements.define('launch-countdown', class extends HTMLElement {
    connectedCallback() {
      this.update();
      if (!this.hidden) this.timer = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const remaining = Math.max(0, Math.ceil((Date.parse(this.dataset.deadline) - Date.now()) / 1000));
      if (!remaining) { this.hidden = true; clearInterval(this.timer); return; }
      const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
      for (const [key,value] of Object.entries(values)) {
        const node = this.querySelector('[data-' + key + ']');
        if (node) node.textContent = String(value).padStart(2,'0');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
